<div class="substitution-fields">
	<label>Fields</label>
	<p>{{ insertMode ? 'Click to insert at the cursor.' : 'Click to copy, then paste.' }}</p>
	<ul>
		<!-- Shown without the braces to save width; the full braced token is what gets copied or inserted. -->
		<li *ngFor="let field of substitutionFields" (click)="copyToClipboard(field)" [title]="(insertMode ? 'Insert ' : 'Copy ') + field">
			<span class="name">{{ displayName(field) }}</span>
			<span class="material-symbols-outlined">{{ insertMode ? 'add' : 'content_copy' }}</span>
		</li>
		<li *ngIf="showVimeoOption" (click)="showCopyVimeoUrlDialog()" title="Build a Vimeo video link">
			<span class="name">Vimeo URL…</span>
			<span class="material-symbols-outlined">{{ insertMode ? 'add' : 'content_copy' }}</span>
		</li>
	</ul>
</div>

<p-dialog [(visible)]="vimeoUrlVisible" [header]="insertMode ? 'Insert Vimeo Url' : 'Copy Vimeo Url'" [style]="{ width: '35%' }">
	<p>Enter the ID of the Vimeo video</p>
	<div class="vimeo-form">
		<div class="field">
			<label>Vimeo video ID</label>
			<input pInputText [(ngModel)]="vimeoVideoId" />
		</div>
	</div>
	<footer class="vimeo-footer">
		<div class="button success" (click)="copyVimeoUrl()">{{ insertMode ? 'Insert' : 'Copy to Clipboard' }}</div>
		<div class="button neutral" (click)="vimeoUrlVisible = false">Cancel</div>
	</footer>
</p-dialog>
